package diana.soleil.design.iraniancanadienbazzar.core.model

import kotlinx.serialization.Serializable

/**
 * A member account as the admin console sees it (`users/{uid}`, admin-only list read). Display
 * fields are tolerant — `users` docs are created lazily on first sign-in and may miss any of them.
 */
@Serializable
data class UserAccount(
    val uid: String,
    val displayName: String? = null,
    val role: String = ROLE_USER,
    val metroId: String? = null,
    val preferredLanguage: String? = null,
) {
    val isAdmin: Boolean get() = role == ROLE_ADMIN

    /** A delegated content moderator — the reports queue + content hide/restore, but NOT admin powers. */
    val isModerator: Boolean get() = role == ROLE_MODERATOR

    /** May act on the moderation queue (admins are a superset of moderators). */
    val canModerate: Boolean get() = isAdmin || isModerator

    companion object {
        const val ROLE_USER = "user"
        const val ROLE_ADMIN = "admin"
        const val ROLE_MODERATOR = "moderator"

        /** True for any role string that grants moderation rights (used off a raw `users/{uid}.role`). */
        fun canModerate(role: String?): Boolean = role == ROLE_ADMIN || role == ROLE_MODERATOR
    }
}
